import { classNames } from '@framework/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePopupRef } from '@framework/hooks';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { LinkLineStyle } from '@model-framework/link';
import { forwardRef, useCallback, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
type Props = {
  onLineStyleSelected(lineStyle: LinkLineStyle): void;
  onOpenSubMenu(menuType: string): void;
};

export const LinkLineStyleMenuButton = forwardRef<
  {
    closePopup: () => void;
  },
  Props
>(({ onLineStyleSelected, onOpenSubMenu }, ref) => {
  const { t } = useTranslation();
  const { isOpen, popupRef, handleToggle, handleClose } = usePopupRef<HTMLDivElement>(false);

  useImperativeHandle(ref, () => ({
    closePopup: () => handleClose(),
  }));

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.stopPropagation();
      onOpenSubMenu('lineStyle');
      handleToggle();
    },
    [handleToggle, onOpenSubMenu]
  );

  return (
    <div className="relative hover:bg-gray-200">
      <button
        // data-right-click-menu は親 item をクリックしても閉じないようにするためのマーカー
        data-right-click-menu
        className={classNames('flex w-full cursor-pointer px-8 py-4')}
        onClick={handleClick}
      >
        <div className="inline-block pl-4 pr-6">{t('canvas.menu.lineStyle')}</div>
        <FontAwesomeIcon icon={faAngleRight} className="ml-auto" />
      </button>
      <div
        className={classNames(
          'absolute -right-32 top-0 z-50 w-32 rounded-lg bg-white py-4 shadow-2xl',
          isOpen ? 'block' : 'hidden'
        )}
        ref={popupRef}
      >
        <button
          className="flex w-full cursor-pointer px-8 py-4 hover:bg-gray-300"
          onClick={() => onLineStyleSelected(LinkLineStyle.Solid)}
        >
          <svg viewBox="0 0 32 32">
            <g transform={`translate(16, 16)`}>
              <line stroke={'#aaa'} strokeWidth={3} strokeLinecap="round" x1={-10} y1={0} x2={10} y2={0} />
            </g>
          </svg>
        </button>
        <button
          className="flex w-full cursor-pointer px-8 py-4 hover:bg-gray-300"
          onClick={() => onLineStyleSelected(LinkLineStyle.Dashed)}
        >
          <svg viewBox="0 0 32 32">
            <g transform={`translate(16, 16)`}>
              <line
                stroke={'#aaa'}
                strokeWidth={3}
                strokeLinecap="round"
                strokeDasharray="3px 6px"
                x1={-10}
                y1={0}
                x2={10}
                y2={0}
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  );
});

LinkLineStyleMenuButton.displayName = 'LinkLineStyleMenuButton';
